<template>
  <div>
    <div class="grow-1">
      <div class="hvh-flex space-between">
        <h2 class="hvh-h5 mb-4">Geographic Distribution</h2>
        <div class="hvh-flex align-center">
          <b>View</b>
          <v-select class="patient-count-select ml-1 mb-2" v-model="showPatientCountHeatMap" :items="patientCountOptions" itemText="label" itemValue="value" @input="loadHeatMapData(map)" outline hide-details singleLine />
        </div>
      </div>
      <!-- <MapBox style="height: 450px" :mapOptions="mapBoxOptions" @map-created="mapCreated" @refresh-data="loadHeatMapData" @rectangle-selected="rectangleSelected" /> -->

      <MapBox
        style="height: 450px"
        :mapOptions="mapBoxOptions"
        :debounce="1500"
        :isFiltering="isFiltering"
        :selectedStates="value.states"
        @map-created="mapCreated"
        @refresh-data="loadHeatMapData"
        @circle-selected="circleSelected"
        @state-selected="stateSelected"
        ref="mapBox"
      />
      <div class="pt-2 hvh-flex-center">
        <label class="pr-3">{{ heatMapCounts.min() }}</label>
        <div style="width: 50%; height: 15px; background: linear-gradient(90deg, rgba(109, 232, 201, 1) 0%, rgba(39, 108, 152, 1) 100%)"></div>
        <label class="pl-3">{{ heatMapCounts.max() }}</label>
      </div>
      <div class="pt-2 hvh-flex-center">{{ showPatientCountHeatMap ? 'Patient Count per MSA' : 'Prevalence per 100K Patients per MSA' }}</div>
    </div>
  </div>
</template>

<script>
import { interpolateFnc } from '../../../../libraries/common';
import { msaMapOptions } from '../../../../libraries/mapBox';
import MapBox from '../../../analysis/filters/MapBox.vue';
export default {
  components: { MapBox },
  props: ['cohort', 'value', 'selectedStates', 'isFiltering'],
  data() {
    return {
      map: null,
      showPatientCountHeatMap: false,
      underlineStyle: 'text-decoration:underline;',
      mapBoxOptions: msaMapOptions,
      patientCountOptions: [
        { label: 'Patient Count', value: true },
        { label: 'Patient Density', value: false }
      ],
    };
  },
  computed: {
    geoHeatMapData() {
      var chartGeoData = {
        "visualization_type": "geoheatmap",
        "mapId": "us",
        "data": []
      }

      let geoObj = {};
      let geoData = this.cohort.cohortStatistic.cohortLocationStatistics
      for (let i = 0; i < geoData.length; i++) {
        if (!geoObj[geoData[i]["name"]]) {
          geoObj[geoData[i]["name"]] = geoData[i]
        } else {
          geoObj[geoData[i]["name"]]["count"] += geoData[i]["count"]
        }
      }
      for (let k in geoObj) {
        chartGeoData.data.push({
          "id": geoObj[k]["id"],
          "name": geoObj[k]["name"],
          "latitude": geoObj[k]["latitude"],
          "longitude": geoObj[k]["longitude"],
          "count": geoObj[k]["count"]
        })
      }

      return chartGeoData
    },
    geoPatientDensityHeatMapData() {
      var chartGeoData = {
        "visualization_type": "geoheatmap",
        "mapId": "us",
        "data": []
      }

      let geoObj = {};
      let geoData = this.cohort.cohortStatistic.cohortLocationStatistics
      for (let i = 0; i < geoData.length; i++) {
        if (!geoObj[geoData[i]["name"]]) {
          geoObj[geoData[i]["name"]] = geoData[i]
        } else {
          geoObj[geoData[i]["name"]]["count"] += geoData[i]["count"]
        }
      }

      var getCount = count => {
        if (!population) return 0;
        var range = count * 100000 / population;
        return range.round(range < 10 ? 2 : 0);
      };

      let population;
      for (let k in geoObj) {
        population = geoObj[k]["population"] > 0 ? geoObj[k]["population"] : 0
        chartGeoData.data.push({
          "id": geoObj[k]["id"],
          "name": geoObj[k]["name"],
          "latitude": geoObj[k]["latitude"],
          "longitude": geoObj[k]["longitude"],
          "count": getCount(geoObj[k]["count"]),
        })
      }

      return chartGeoData
    },
    heatMapData() {
      return this.showPatientCountHeatMap ? this.geoHeatMapData.data : this.geoPatientDensityHeatMapData.data;
    },
    heatMapCounts() {
      return this.heatMapData.map(f => f.count);
    },
    gradientColorFnc() {
      return interpolateFnc(this.heatMapCounts.map(f => Math.log(f + 1)), [{ value: [96, 232, 197], percent: 0 }, { value: [39, 108, 152], percent: 100 }]);
    },
  },
  methods: {
    createPointSource(map) {
      var interpolateSize = interpolateFnc(this.heatMapCounts, [{ value: [1], percent: 0 }, { value: [20], percent: 100 }]);

      return {
        'type': 'FeatureCollection',
        'features': this.heatMapData
          .map(f => ({
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [f.longitude, f.latitude],
            },
            'properties': {
              title: f.key,
              count: f.count,
              size: interpolateSize(f.count)[0] * map.getZoom() / 3 + 4,
              name: f.name,
              color: `rgb(${this.gradientColorFnc(Math.log(f.count + 1)).join(',')})`,
            }
          })),
      };
    },
    loadHeatMapData(map) {
      var pointsSource = this.createPointSource(map);
      if (!map.getSource('points')) {
        map.addSource('points', {
          'type': 'geojson',
          'data': pointsSource
        });

        map.addLayer({
          id: 'point',
          // 'source': 'point',
          type: 'circle',
          source: 'points',
          paint: {
            'circle-radius': ['get', 'size'],
            'circle-color': ['get', 'color'],
            'circle-opacity': 0.8,
          }
        });
      } else {
        map.getSource('points').setData(this.createPointSource(map));
      }
    },
    mapCreated(map, mapboxgl) {
      this.map = map;
      var popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false
      });

      map.on('mouseenter', 'point', this.showPopup(popup));

      map.on('mouseleave', 'point', function () {
        map.getCanvas().style.cursor = '';
        popup.remove();
      });

      map.on('zoom', () => map.getSource('points').setData(this.createPointSource(map)));

      this.loadHeatMapData(map);
    },
    showPopup(popup) {
      return (e) => {
        this.map.getCanvas().style.cursor = 'pointer';

        var coordinates = e.features[0].geometry.coordinates.slice();
        var description = e.features[0].properties.name + `<br />Patients${(this.showPatientCountHeatMap ? '' : ' per 100K')}: ` + e.features[0].properties.count;
        popup.setLngLat(coordinates).setHTML(description).addTo(this.map);
      }
    },
    rectangleSelected(event) {
      this.$emit('input', {
        area: {
          rectangle: event
        }
      });
    },
    circleSelected(event) {
      this.$emit('input', {
        circle: event
      });
    },
    stateSelected(event) {
      this.$emit('input', {
        states: event
      });
    },
    statesRemoved() {
      this.$refs.mapBox.removeStates();
    },
    circleRemoved() {
      this.$refs.mapBox.removeDrawings();
    },
    decilesRemoved() {
      this.decilesRange = [];
    },
  }
}
</script>

<style lang="scss" scoped>
.patient-count-select {
  width: 238px;
}
</style>